export { DetailsForm } from './DetailsForm';
